/* Theme G behaviour: nav flyouts, mobile menu, cart drawer, filter toggle,
 * PDP tabs + sticky bar, collection guide disclosure.
 * Progressive enhancement throughout - every one of these works without JS,
 * just less comfortably.
 */
(function () {
  var d = document;

  /* Sort select posts its owning form on change - it had no handler at all. */
  d.addEventListener("change", function (e) {
    var s = e.target.closest(".collection-sort, [name='sort_by']");
    if (!s) return;
    var form = s.form || d.getElementById(s.getAttribute("form"));
    if (form) form.submit();
  });

  /* PDP quantity stepper: +/- buttons had no handler; submit reads [name=quantity]. */
  d.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty-up], [data-qty-down]");
    if (!b) return;
    var q = (b.closest(".buy-qty") || d).querySelector("[data-qty-input]");
    if (!q) return;
    q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (b.hasAttribute("data-qty-up") ? 1 : -1));
  });

  /* ---- Mega flyout. Hover on pointer devices, click on touch. ---- */
  function flyouts() {
    var items = d.querySelectorAll("[data-flyout-parent]");
    var canHover = window.matchMedia("(hover: hover)").matches;
    var openItem = null;
    var closeTimer;

    function close(item) {
      var panel = item.querySelector("[data-flyout]");
      var trigger = item.querySelector("a[aria-expanded]");
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (openItem === item) openItem = null;
    }
    function open(item) {
      if (openItem && openItem !== item) close(openItem);
      var panel = item.querySelector("[data-flyout]");
      var trigger = item.querySelector("a[aria-expanded]");
      if (panel) panel.hidden = false;
      if (trigger) trigger.setAttribute("aria-expanded", "true");
      openItem = item;
    }

    items.forEach(function (item) {
      if (!item.querySelector("[data-flyout]")) return;

      if (canHover) {
        item.addEventListener("mouseenter", function () { clearTimeout(closeTimer); open(item); });
        item.addEventListener("mouseleave", function () {
          closeTimer = setTimeout(function () { close(item); }, 140);
        });
      }

      var trigger = item.querySelector("a[aria-expanded]");
      if (trigger) {
        trigger.addEventListener("click", function (e) {
          // On touch the first tap opens; the second follows the link.
          if (!canHover && trigger.getAttribute("aria-expanded") !== "true") {
            e.preventDefault();
            open(item);
          }
        });
      }

      // Focus leaving the subtree closes it - keyboard users get out cleanly.
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    d.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && openItem) { close(openItem); }
    });
  }

  /* ---- Panels: mobile menu + cart drawer ---- */
  function panel(selector, openSel, closeSel) {
    var el = d.querySelector(selector);
    if (!el) return;
    var lastFocus = null;

    function setOpen(state) {
      el.setAttribute("aria-hidden", state ? "false" : "true");
      d.documentElement.style.overflow = state ? "hidden" : "";
      var trigger = d.querySelector(openSel);
      if (trigger && trigger.hasAttribute("aria-expanded")) {
        trigger.setAttribute("aria-expanded", state ? "true" : "false");
      }
      if (state) {
        lastFocus = d.activeElement;
        var first = el.querySelector("button, a, input");
        if (first) first.focus();
      } else if (lastFocus) { lastFocus.focus(); }
    }

    d.querySelectorAll(openSel).forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        // Cart link still works without JS, so only hijack when we can render.
        if (btn.tagName === "A" && !el) return;
        e.preventDefault();
        setOpen(true);
      });
    });
    el.querySelectorAll(closeSel).forEach(function (btn) {
      btn.addEventListener("click", function () { setOpen(false); });
    });
    d.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && el.getAttribute("aria-hidden") === "false") setOpen(false);
    });
  }

  /* ---- Collection: filter drawer on mobile ---- */
  function filterToggle() {
    var panelEl = d.querySelector(".collection-filters");
    if (!panelEl) return;
    // Delegated: the toolbar button opens, the drawer's own close button closes.
    d.addEventListener("click", function (e) {
      if (!e.target.closest("[data-filter-toggle]")) return;
      var open = panelEl.classList.toggle("is-open");
      d.documentElement.style.overflow = open ? "hidden" : "";
    });
    // Auto-submit so a filter change applies without hunting for a button.
    var form = d.getElementById("CollectionFilterForm");
    if (form) {
      // The find box is a text input inside the form: it fires change on blur and
      // submits implicitly on Enter. Both would reload the page mid-search.
      form.addEventListener("change", function (e) {
        if (e.target && e.target.closest("[data-filter-find]")) return;
        form.submit();
      });
      form.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        if (e.target && e.target.closest("[data-filter-find]")) e.preventDefault();
      });
    }
  }

  /* ---- PDP: tab scroll-spy ---- */
  function pdpTabs() {
    var tabs = Array.prototype.slice.call(d.querySelectorAll(".pdp-tab"));
    if (!tabs.length) return;
    var regions = tabs.map(function (t) {
      return d.querySelector(t.getAttribute("href"));
    }).filter(Boolean);
    if (!regions.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        tabs.forEach(function (t) {
          t.setAttribute("aria-selected", t.getAttribute("href") === "#" + entry.target.id ? "true" : "false");
        });
      });
    }, { rootMargin: "-80px 0px -70% 0px" });
    regions.forEach(function (r) { obs.observe(r); });
  }

  /* ---- PDP: sticky bar mirrors the real buy button ---- */
  function stickyBar() {
    var bar = d.querySelector("[data-buy-sticky]");
    var submit = d.querySelector("[data-add-to-cart]");
    if (!bar || !submit) return;

    d.querySelector("[data-sticky-add]").addEventListener("click", function () { submit.click(); });

    var price = d.querySelector("[data-price]");
    var out = d.querySelector("[data-sticky-price]");
    if (price && out) {
      new MutationObserver(function () { out.textContent = price.textContent; })
        .observe(price, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---- Collection: buying-guide disclosure on mobile ---- */
  function guideMore() {
    var btn = d.querySelector("[data-guide-more]");
    var body = d.querySelector("[data-collapsible]");
    if (!btn || !body) return;
    btn.addEventListener("click", function () {
      body.classList.add("is-open");
      btn.hidden = true;
    });
  }

  /* ---- Collection: type-to-find inside a long filter group ---- */
  function filterFind() {
    var boxes = d.querySelectorAll("[data-filter-find]");
    if (!boxes.length) return;
    Array.prototype.forEach.call(boxes, function (box) {
      var group = box.closest(".filter-group");
      if (!group) return;
      var list = group.querySelector("[data-filter-list]");
      var none = group.querySelector("[data-filter-find-empty]");
      if (!list) return;
      var rows = Array.prototype.slice.call(list.querySelectorAll(".filter-check"));
      box.addEventListener("input", function () {
        var q = box.value.trim().toLowerCase();
        var shown = 0;
        rows.forEach(function (row) {
          var hit = !q || (row.getAttribute("data-filter-name") || "").indexOf(q) !== -1;
          row.hidden = !hit;
          if (hit) shown++;
        });
        if (none) none.hidden = shown !== 0;
        list.scrollTop = 0;
      });
    });
  }

  function init() {
    flyouts();
    panel("[data-mobile-menu]", "[data-menu-open]", "[data-menu-close]");
    panel("[data-cart-drawer]", "[data-cart-open]", "[data-cart-close]");
    filterToggle();
    filterFind();
    pdpTabs();
    stickyBar();
    guideMore();
  }

  if (d.readyState === "loading") { d.addEventListener("DOMContentLoaded", init); }
  else { init(); }
})();
